import React, { Suspense, lazy } from "react";
import Spinner from "./ui/spinner";
import SEO from "../seo/SEO";
import { SEO_PAGES, getBreadcrumbSchema } from "../seo/seoConfig";
import UseCasesHero from "./pages/use-cases/use-cases-hero";
import UseCaseCard from "./pages/use-cases/use-case-card";
import UseCasesCta from "./pages/use-cases/use-cases-cta";
import { DemoAccessProvider } from "./pages/use-cases/demo-access-context";
import { USE_CASES } from "./pages/use-cases/use-cases-data";

const Footer = lazy(() => import("./footer"));

export const UseCasesPage = () => {
  const seo = SEO_PAGES.useCases;

  return (
    <>
      <SEO
        {...seo}
        schemas={[
          getBreadcrumbSchema([
            { name: "Home", path: "/" },
            { name: "AI Use Cases", path: "/use-cases" },
          ]),
        ]}
      />
      <DemoAccessProvider>
        <div id="use-cases-page">
          <main className="flex flex-col bg-white">
            <UseCasesHero />

            <section className="pb-12 sm:pb-20 lg:pb-24 min-w-0">
              <div className="page-container space-y-12 sm:space-y-16 lg:space-y-24 min-w-0">
                {USE_CASES.map((useCase, index) => (
                  <UseCaseCard key={useCase.id} useCase={useCase} index={index} />
                ))}
              </div>
            </section>

            <UseCasesCta />

            <Suspense fallback={<Spinner />}>
              <Footer />
            </Suspense>
          </main>
        </div>
      </DemoAccessProvider>
    </>
  );
};
